import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignPageComponent } from './sign-page.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatProgressBarModule
  ],
  declarations: [SignPageComponent]
})
export class SignPageModule { }
